import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  ApplicationState,
  getPasswordRecoveryState,
} from '../../../store/reducers';
import * as RecoveryMethodsActions from '../../store/actions/password-recovery-management.actions';
import { Store } from '@ngrx/store';
import { PasswordRecoveryManagementState } from '../../store/reducers/password-recovery-management.reducer';
import { OnDestroyNewHookDirective } from '../../../shared/hooks';

@Component({
  selector: 'mprd-mobile-active-container',
  templateUrl: 'mobile-active-container.component.html',
})
export class MobileActiveContainerComponent
  extends OnDestroyNewHookDirective
  implements OnInit, OnDestroy
{
  @ViewChild('newMobileNumberInput') newMobileNumberInput;

  mobileNumber: string;
  newMobileNumber = '';
  isNewMobileNumberValid = false;
  showChangeNumber = false;

  constructor(private store: Store<ApplicationState>) {
    super();
  }

  ngOnInit() {
    this.store
      .select(getPasswordRecoveryState)
      .subscribe(
        (passwordRecoveryManagementState: PasswordRecoveryManagementState) => {
          if (
            passwordRecoveryManagementState.passwordRecoveryManagement &&
            passwordRecoveryManagementState.passwordRecoveryManagement.sms
          ) {
            this.mobileNumber =
              passwordRecoveryManagementState.passwordRecoveryManagement.sms.mobile;
          }
        },
      );
  }

  onMobileNumberSubmitFormStatusAndValue(mobileNumberSubmitFormStatusAndValue: {
    mobileNumberSubmitFormStatus: string;
    mobileNumber: string;
    errors: any;
  }) {
    if (mobileNumberSubmitFormStatusAndValue.mobileNumberSubmitFormStatus) {
      this.showChangeNumber = false;
      this.setSmsRecovery(mobileNumberSubmitFormStatusAndValue.mobileNumber);
    }
  }

  setSmsRecovery(mobileNumber = this.mobileNumber) {
    this.store.dispatch(
      new RecoveryMethodsActions.SetSmsRecoveryMethodAction(mobileNumber),
    );
  }

  onMobileNumberSubmitCancel() {
    this.showChangeNumber = !this.showChangeNumber;
  }

  validateMobileNumber() {
    this.isNewMobileNumberValid = this.newMobileNumber?.length === 10;
  }

  isValid() {
    return this.isNewMobileNumberValid;
  }

  isNewMobileNumberEmpty() {
    return this.newMobileNumber?.length === 0;
  }

  reset() {
    this.newMobileNumberInput.reset();
    this.newMobileNumber = '';
    this.isNewMobileNumberValid = false;
  }
}
